module.exports = __webpack_public_path__ + "GoogleAnalytics.png";